import { Icons, tokens } from '@cast/design-system';

export const GreenCheckIcon = () => (
  <Icons.Check color={tokens.theme.fg.status.success} weight="bold" />
);

export const RedXIcon = () => (
  <Icons.X color={tokens.theme.fg.status.error} weight="bold" />
);
